<template>
    <section class="hs-card">
        <header class="hs-header">
            <h2 class="hs-title">{{ $t('dashboard.shortcuts_title') }}</h2>
            <p class="hs-text">{{ $t('dashboard.shortcuts_text') }}</p>
        </header>

        <div v-if="shortcuts.length" class="hs-grid">
            <router-link
                v-for="shortcut in shortcuts"
                :key="shortcut.to"
                :to="shortcut.to"
                class="hs-tile"
            >
                <span class="hs-tile-icon">
                    <i :class="shortcut.icon || 'fal fa-arrow-right'"></i>
                </span>
                <span class="hs-tile-label">{{ $t(shortcut.label) }}</span>
                <i class="fal fa-arrow-right hs-tile-arrow"></i>
            </router-link>
        </div>

        <p v-else class="hs-empty">{{ $t('dashboard.shortcuts_empty') }}</p>
    </section>
</template>

<script>
export default {
    name: 'HomeShortcuts',
    props: {
        /** `[{ label, icon, to }]` — voir `allowedNavSections` dans config/navigation. */
        shortcuts: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style scoped>
.hs-card {
    padding: 28px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    background: var(--v2-surface-0);
}

.hs-header {
    margin-bottom: 20px;
}

.hs-title {
    margin: 0 0 4px;
    font-size: 1.05rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
}

.hs-text {
    margin: 0;
    max-width: 620px;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.hs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 12px;
}

.hs-tile {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    background: var(--v2-surface-0);
    color: var(--v2-text-1);
    text-decoration: none !important;
    transition: border-color var(--v2-transition-fast), background var(--v2-transition-fast);
}

.hs-tile:hover {
    border-color: #a5f3fc;
    background: #f8fdff;
}

.hs-tile-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border-radius: var(--v2-radius-md);
    background: #ecfeff;
    color: var(--v2-primary);
    font-size: 1rem;
}

.hs-tile-label {
    flex: 1 1 auto;
    min-width: 0;
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-medium);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hs-tile-arrow {
    flex: 0 0 auto;
    font-size: 0.8rem;
    color: var(--v2-text-4);
}

.hs-tile:hover .hs-tile-arrow {
    color: var(--v2-primary);
}

.hs-empty {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
}

@media (max-width: 720px) {
    .hs-card {
        padding: 20px 18px;
    }

    .hs-grid {
        grid-template-columns: 1fr;
    }
}
</style>
